<template>
<div class="homepage">
    <div class="backdrop"></div>
    <div class="card-container">
        <q-card class="homepage__card col-lg-offset-2">
            <q-card-section>
                <div :class="{'q-mt-md q-mx-md': !$isMobile, 'q-pa-md': $isMobile}">
                    <h1 class="heading-2 q-mb-lg text-primary">Vind de richtlijnen voor uw project</h1>
                </div>
                <q-tabs v-if="searchEnabled"
                        v-model="panel"
                        class="text-neutral-90 q-px-md"
                        active-color="primary"
                        indicator-color="primary"
                        align="justify"
                >
                    <q-tab name="search" label="Direct zoeken" />
                    <q-tab name="login" label="Inloggen" />
                </q-tabs>
                <q-tab-panels v-model="panel" animated>
                    <q-tab-panel v-if="searchEnabled" name="search">
                        <div class="column q-pt-md" :class="$isMobile ?'q-gutter-y-md' : 'q-gutter-lg'">
                            <template v-if="hasWelcomeText">
                                <welcomeText />
                            </template>
                            <template v-if="ruleCatalogEnabled">
                                <primary-button align="left"
                                                label="Alle richtlijnen"
                                                icon="list" @click="$goto('rule.catalog')" />
                                <primary-button align="left" label="Zoek richtlijnen" icon="search"
                                                @click="$goto('search.start')" />
                            </template>
                            <primary-button v-else align="left" label="Zoek richtlijnen" icon="search"
                                            @click="$goto('search.start')" />
                            <primary-button v-if="hasObjects" align="left"
                                            :label="$isMobile ? 'Inrichtingselementen' : 'Inrichtingselementencatalogus'"
                                            icon="list" @click="$goto('object.catalog')" />
                            <primary-button align="left" label="Vul projectcode in" icon="edit"
                                            @click="projectCodeDialog = true" />
                            <flat-button v-if="hasExtraInformation"
                                         align="left" label="Meer informatie"
                                         icon="help_outline"
                                         outline
                                         @click="$goto('extra-information')" />
                        </div>
                    </q-tab-panel>
                    <q-tab-panel name="login">
                        <template v-if="ssoAvailable">
                            <div class="column q-gutter-lg q-mb-lg">
                                <primary-button
                                    label="Login met Azure"
                                    :href="$route('auth.login.withAzure')" />
                                <flat-button v-show="!isFormVisible"
                                             type="submit"
                                             :label="`Login met ${platformTitle} Account`"
                                             outline
                                             class="q-mb-sm"
                                             @click="loginExpanded = true"
                                             :aria-expanded="isFormVisible"
                                             aria-controls="login-form" />
                            </div>
                        </template>
                        <q-slide-transition>
                            <common-form :action="$route('auth.authenticate')"
                                         v-show="isFormVisible">
                                <div id="login-form" class="column q-gutter-lg"
                                     :hidden="!isFormVisible">
                                    <input type="hidden" name="from_modal" value="1" />
                                    <common-input name="email" v-model="form.email" label="E-mailadres"
                                                  class="col-12"
                                                  :error-message="$errorMessage('email')"
                                                  :error="$hasError('email')"
                                                  autofocus
                                    />
                                    <common-input name="password"
                                                  v-model="form.password"
                                                  label="Wachtwoord"
                                                  type="password"
                                                  class="col-12"
                                                  :error-message="$errorMessage('password')"
                                                  :error="$hasError('password')"
                                    />
                                    <q-checkbox class="col-12"
                                                name="remember_me"
                                                v-model="form.remember_me"
                                                true-value="1"
                                                label="Ingelogd blijven" />
                                    <flat-button type="submit"
                                                 outline
                                                 label="Inloggen" />
                                </div>
                                <div class="q-mt-lg">
                                    <common-link v-if="registerEnabled" class="q-mb-sm" label="Nog geen account"
                                                 :href="$route('auth.register')" />
                                    <common-link label="Wachtwoord vergeten" href="#"
                                                 @click.prevent="resetDialog = true" />
                                </div>
                            </common-form>
                        </q-slide-transition>
                    </q-tab-panel>
                </q-tab-panels>
            </q-card-section>
        </q-card>
    </div>
</div>
<password-reset-dialog v-model="resetDialog" />
<project-code-dialog v-model="projectCodeDialog" />
</template>

<script>
import PasswordResetDialog from '~HIOR/pages/auth/dialog/PasswordReset'
import ProjectCodeDialog from '~HIOR/components/dialog/ProjectCodeDialog'
import { config } from '~INSTANCE'

export default {
    components: {
        PasswordResetDialog,
        ProjectCodeDialog,
        welcomeText: config.welcomeText,
    },
    props: {
        hasObjects: {
            type: Boolean,
            default: false,
        },
        searchEnabled: {
            type: Boolean,
            default: false,
        },
        registerEnabled: {
            type: Boolean,
            default: false,
        },
        ruleCatalogEnabled: {
            type: Boolean,
            default: false,
        },
        ssoAvailable: {
            type: Boolean,
        },
    },
    computed: {
        hasWelcomeText () {
            return !!config.welcomeText
        },
        hasExtraInformation () {
            return !!config.extraInformation
        },
        platformTitle () {
            return config.translations?.title ?? 'HIOR'
        },
        isFormVisible () {
            return this.loginExpanded || !this.ssoAvailable || this.$hasError('email') || this.$hasError('password')
        },
    },
    data () {
        return {
            projectCodeDialog: false,
            resetDialog: false,
            loginExpanded: false,
            panel: this.$hasAnyErrors() || !this.searchEnabled ? 'login' : 'search',
            form: {
                email: this.$old('email'),
                password: '',
                remember_me: this.$old('remember_me', false),
            },
        }
    },
}
</script>
